import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const API_URL = `${API_BASE_URL.replace(/\/$/, '')}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token && token !== 'null' && token !== 'undefined') {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
    }
    return Promise.reject(error);
  }
);

export const getPuzzles = async () => {
  try {
    const response = await api.get('/puzzles');
    return response.data;
  } catch (error) {
    console.error('Error fetching puzzles:', error);
    throw error;
  }
};

export const getLatestPuzzles = async (limit: number = 3) => {
  try {
    const response = await api.get(`/puzzles/latest?limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching latest puzzles:', error);
    throw error;
  }
};

export const createOrder = async (orderData: any) => {
  try {
    const response = await api.post('/orders', orderData);
    return response.data;
  } catch (error) {
    console.error('Error creating order:', error);
    throw error;
  }
};

export const getUserOrders = async (userId: string) => {
  try {
    const response = await api.get(`/orders`, {
      params: { userId },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user orders:', error);
    throw error;
  }
};

// File upload functions
export const uploadMultipleFiles = async (files: File[]) => {
  const formData = new FormData();
  files.forEach(file => {
    formData.append('file', file);
  });

  const response = await api.post('/uploads/multiple', formData, {
    headers: { 
      'Content-Type': 'multipart/form-data',
    }
  });
  return response.data;
};

export const uploadSingleFile = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await api.post('/uploads/single', formData, {
    headers: { 
      'Content-Type': 'multipart/form-data',
    }
  });
  return response.data;
};

// Puzzle Option Endpoints
export const getPuzzleOptions = async (puzzleId: string) => {
  const response = await api.get(`/puzzles/${puzzleId}/options`);
  return response.data;
};

export const getAllPuzzleOptions = async (puzzleId: string) => {
  const response = await api.get(`/puzzles/${puzzleId}/options/admin`);
  return response.data;
};

export const createPuzzleOption = async (puzzleId: string, data: { name: string; price: number; weight?: number }) => {
  const response = await api.post(`/puzzles/${puzzleId}/options`, data);
  return response.data;
};

export const updatePuzzleOption = async (optionId: string, data: any) => {
  const response = await api.put(`/puzzles/options/${optionId}`, data);
  return response.data;
};

export const deletePuzzleOption = async (optionId: string) => {
  const response = await api.delete(`/puzzles/options/${optionId}`);
  return response.data;
};

export default api; 